import { useSetAtom, useAtom, atom } from 'jotai';

const postExitOfferAtom = atom(false);

// Write-only, for callers that must not re-render on the offer's state —
// `AuthProvider` resets it at sign-out and is the root of the whole app.
export const useSetPostExitOffer = () => useSetAtom(postExitOfferAtom);

// F9 — the "create a new profile?" offer shown AFTER a successful
// leave/close once the user no longer owns any organization. Global (atom +
// AppLayout host) because the exit wizard navigates away on success — the
// page that opened the wizard unmounts, so a locally-rendered dialog would
// die before it ever showed.
export const usePostExitOfferStore = () => {
  const [isPostExitOfferOpen, setPostExitOfferOpen] =
    useAtom(postExitOfferAtom);

  return { isPostExitOfferOpen, setPostExitOfferOpen };
};
